export default "__VITE_ASSET__Dw1TIU6M__"